export const NodeTypes = {
  settingsNode: 'settingsNode',
  errorNode: 'errorNode',
  conditionalNode: 'conditionalNode',
  testGroupsNode: 'testGroupsNode',
  transactionNatureNode: 'transactionNatureNode',
  recurringActionNode: 'recurringActionNode',
  valueNode: 'valueNode',
  debtCollectionNode: 'debtCollectionNode',
  failureNode: 'failureNode',
  successNode: 'successNode',
} as const;
